<template>
  <div>
    <Header id="homeHeader" />
    <main class="main">
      <HomeSlider />
      <specialCategories />
      <PropertiesHome />
      <freeShippingSlider />
      <template v-if="specialCategories && specialCategories.length">
        <CategoryItems v-for="cate in specialCategories" :item="cate" />
      </template>
      <RecommendedProduct />
      <!-- <CustomerComments /> -->
      <Weblogs class="mt-5"/>
    </main>
  </div>
</template>
<script>
import Header from "@/parts/Front/components/shared/Header";
import Weblogs from "@/parts/Front/components/Weblogs";
import HomeSlider from "@/parts/Front/components/home/HomeSlider.vue";
import PropertiesHome from "@/parts/Front/components/home/PropertiesHome.vue";
import RecommendedProduct from "@/parts/Front/components/RecommendedProduct.vue";
import CustomerComments from "@/parts/Front/components/home/CustomerComments.vue";
import specialCategories from "@/parts/Front/components/home/specialCategories.vue";
import freeShippingSlider from "@/parts/Front/components/home/freeShippingSlider.vue";
import CategoryItems from "@/parts/Front/components/home/CategoryItems.vue";
export default {
  name: "Home",
  components: {
    Header,
    Weblogs,
    HomeSlider,
    PropertiesHome,
    RecommendedProduct,
    CustomerComments,
    specialCategories,
    freeShippingSlider,
    CategoryItems,
  },
  mounted() {
    if (!this.specialCategories) {
      this.$store.dispatch("front/getSpecialCategoriesFromServer");
    }
  },
  computed: {
    specialCategories() {
      return this.$store.getters["front/getSpecialCategories"];
    },
   
  },
};
</script>
<style scoped></style>
